import React from 'react';
import { observer } from '../../shared/observer';
import { runBusy, isBusy } from '../../shared/busy';

class AddressesView extends React.Component {
  state = { loading: true, error: null, busy: {} };

  async componentDidMount() {
    try { await this.props.address.getAddresses(); this.setState({ loading: false }); }
    catch (e) { this.setState({ loading: false, error: e.message }); }
  }

  remove = (id) => () => {
    if (isBusy(this, 'remove:' + id)) return;
    if (!window.confirm('Удалить адрес?')) return;
    this.setState({ error: null });
    runBusy(this, 'remove:' + id, () => this.props.address.deleteAddress(id))
      .catch((e) => this.setState({ error: e.message || 'Не удалось удалить адрес' }));
  };

  edit = (a) => () => this.props.address.openEditDialog(a);

  add = () => this.props.address.openAddDialog();

  render() {
    if (this.state.loading) return <p>Загрузка…</p>;
    const list = this.props.address.addresses || [];

    return (
      <div>
        <h1>Адреса</h1>
        {this.state.error && <div className="order-message">{this.state.error}</div>}
        {list.length === 0 && !this.state.error && (
          <p className="ng-checkout__hint">У вас пока нет адресов.</p>
        )}
        {list.length > 0 && (
          <ul className="ng-addresses">
            {list.map((a) => {
              const removing = isBusy(this, 'remove:' + a.id);
              return (
                <li key={a.id}>
                  <div>
                    <strong>{a.full_addr_with_city || a.full_addr}</strong>
                    {a.client_comment && <div className="ng-checkout__hint">{a.client_comment}</div>}
                  </div>
                  <div className="ng-addresses__actions">
                    <button type="button" className="btn btn--ghost btn--mini" disabled={removing} onClick={this.edit(a)}>Изменить</button>
                    <button type="button" className={'btn btn--ghost btn--mini' + (removing ? ' is-busy' : '')} disabled={removing} onClick={this.remove(a.id)}>Удалить</button>
                  </div>
                </li>
              );
            })}
          </ul>
        )}

        <button type="button" className="btn" onClick={this.add}>+ Добавить адрес</button>
      </div>
    );
  }
}

export const Addresses = observer(AddressesView, ['addressStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/Addresses.jsx